import React from 'react'

const Prof = () => {
    return (
        <div className='container'>
            <h1>COMPUTER PROGRAMMING PROFESSOR CAREERS</h1>
            <section id="cmp-intro-section" class="content-blurb-container">
    <div class="row mx-0">
        <div class="col-xl-8 col-lg-7 col-12 px-0">
            <h2 class="text-break mt-48">Computer Programming Professor Careers</h2>
            <div class="content no-margin">
                <section>
                    <p>There is more than meets the eye when it comes to being a computer programming professor. For
                        example, did you know that they make an average of $35.85 an hour? That's $74,576 a year!</p>
                    <p>Between 2018 and 2028, the career is expected to grow 11% and produce 155,000 job opportunities
                        across the U.S.</p>
                </section>
            </div>
            <h3>What Does a Computer Programming Professor Do</h3>
            <div class="content blurb open" id="whatTheyDo" style={{maxHeight: 'none'}}>
                <section>
                    <p>There are certain skills that many computer programming professors have in order to accomplish
                        their responsibilities. By taking a look through resumes, we were able to narrow down the most
                        common skills for a person in this position. We discovered that a lot of resumes listed
                        interpersonal skills, speaking skills and writing skills.</p>
                    <p>When it comes to the most important skills required to be a computer programming professor, we
                        found that a lot of resumes listed 18.3% of computer programming professors included hardware,
                        while 16.5% of resumes included professional development, and 13.5% of resumes included
                        internet. <a class="alink" href="https://www.zippia.com/advice/hard-skills/">Hard skills</a>
                        like these are helpful to have when it comes to performing essential job responsibilities.</p>
                    <p>When it comes to searching for a job, many search for a key term or phrase. Instead, it might be
                        more helpful to search by industry, as you might be missing jobs that you never thought about in
                        industries that you didn't even think offered positions related to the computer programming
                        professor job title. But what industry to start with? Most computer programming professors
                        actually find jobs in the education and technology industries. </p>
                </section>
            </div>
            <h3>How To Become a Computer Programming Professor</h3>
            <div class="content blurb open" id="howToBecome" style={{maxHeight: 'none'}}>
                <section>
                    <p>If you're interested in becoming a computer programming professor, one of the first things to
                        consider is how much education you need. We've determined that 50.0% of computer programming
                        professors have a bachelor's degree. In terms of higher education levels, we found that 25.4% of
                        computer programming professors have master's degrees. Even though most computer programming
                        professors have a college degree, it's possible to become one with only a high school degree or
                        GED.</p>
                    <p>Choosing the right major is always an important step when researching how to become a computer
                        programming professor. When we researched the most common majors for a computer programming
                        professor, we found that they most commonly earn bachelor's degree degrees or master's degree
                        degrees. Other degrees that we often see on computer programming professor resumes include
                        doctoral degree degrees or associate degree degrees.</p>
                    <p>You may find that experience in other jobs will help you become a computer programming professor.
                        In fact, many computer programming professor jobs require experience in a role such as
                        professor. Meanwhile, many computer programming professors also have previous career experience
                        in roles such as teacher or adjunct professor. </p>
                </section>
            </div>
            
        </div>
       
     
    </div>
</section>
        </div>
    )
}

export default Prof
